import { HttpErrorResponse } from '@angular/common/http';

const ACCEPT_CONFIRM = 'accept-confirm';

export type AcceptConfirm = {
  fields: Record<string, true>;
  message: string;
};

type ValidationBody = {
  errors?: Record<string, string | string[]>;
};

export function acceptConfirmOf(error: HttpErrorResponse | null | undefined): AcceptConfirm | null {
  const errors = (error?.error as null | undefined | ValidationBody)?.errors;
  const confirm = errors?.[ACCEPT_CONFIRM];
  if (!confirm) return null;

  const names = (Array.isArray(confirm) ? confirm : [confirm]).filter(Boolean);
  if (!names.length) return null;

  return {
    fields: Object.fromEntries(names.map((name): [string, true] => [name, true])),
    message: messageOf(errors),
  };
}

function messageOf(errors: Record<string, string | string[]>): string {
  return (
    Object.entries(errors)
      .filter(([field]): boolean => field !== ACCEPT_CONFIRM)
      .flatMap(([, value]): string[] => (Array.isArray(value) ? value : [value]))
      .find(Boolean) ?? ''
  );
}
